module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMAEZYipTOM+ezVwHVDOTAGDQj06OTHtqGFbGhHLArB7AtBAAAAnklEQVQoz93TSQ6DMBBE0QIDZjJmnlP3P2YwxKQV5QS85ZdXJTecQMIlTiml2/VypKR3AGVWYm1FLXBIyKRRwx1zOCGPDFTxh71rBOFhdUKjvNpXbVRHLzur6TkjF0PaJXCjL7agGHJmb+Bkd+yU0WR41lp5L0z0VYoeVq3/TxWQ+CqGHFQTkomLBb/a9fy7wK4pjTWc7ecCKuD/tbwBJqceMkjJjY8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-5.png
// module id = cHA+
// module chunks = 1